import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faBriefcase,
  faPaperPlane,
  faQuestion,
  faImage,
  faDownload,
  faHandFist,
  faCopy,
  faEarthAmericas
} from "@fortawesome/free-solid-svg-icons";
import SubMenu from "./SubMenu";
import { NavItem, NavLink, Nav } from "reactstrap";
import classNames from "classnames";


// import "../../i18n";

import { withTranslation } from 'react-i18next';

class SideBar extends React.Component {

  

  render() {

    const { t } = this.props;


    return (
      <div   className={classNames("sidebar", { "is-open": this.props.isOpen })}>
        <div className="sidebar-header">
          <a color="info" onClick={this.props.toggle} style={{ color: "#fff" }}>
            &times;
          </a>
          <h3>Android CCTV</h3>
        </div>
        <Nav vertical className="list-unstyled pb-3">
          <p></p>
          {/* <SubMenu
          style={{ color: "#ffff" }}
            title="Home"
            icon={faHome}
            items={["Home 1", "Home 2", "Home 3"]}
          /> */}

          <NavItem>
            <NavLink href="/cctv" style={ {fontSize : 20, color: "#1a1515"} }>
              <FontAwesomeIcon icon={faHome} className="mr-2" style={ {marginRight : 10} } />
               Home
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink href="./live" style={ {fontSize : 20,color: "#1a1515"} }>
              <FontAwesomeIcon icon={faEarthAmericas} className="mr-2" style={ {marginRight : 10} } />
              {t("Live")}
            </NavLink>
          </NavItem>

          {/* <NavItem>
            <NavLink href="./live3" style={ {fontSize : 20,color: "#1a1515"} }>
              <FontAwesomeIcon icon={faEarthAmericas} className="mr-2" style={ {marginRight : 10} } />
              {t("Live2")}
            </NavLink>
          </NavItem> */}

          <NavItem>
            <NavLink href="./download" style={ {fontSize : 20,color: "#1a1515"} }>
              <FontAwesomeIcon icon={faDownload} className="mr-2" style={ {marginRight : 10} } />
              {t("download")}
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink href="./features" style={ {fontSize : 20,color: "#1a1515"} }>
              <FontAwesomeIcon icon={faHandFist} className="mr-2" style={ {marginRight : 10} } />
              {t("features")}
            </NavLink>
          </NavItem>

          {/* <NavItem>
            <NavLink href="./howto" style={ {fontSize : 20,color: "#fff"} }>
              <FontAwesomeIcon icon={faBriefcase} className="mr-2" style={ {marginRight : 10} } />
              How to use
            </NavLink>
          </NavItem> */}

          <SubMenu
            title={t("howtouse")}
            icon={faCopy}
            items={[{title : " - "+t("start_cctv_mode"),link : "./howto"}, {title : t("submenu_event_alarm"),link : "./howtoevent"}]}
            
          />

          <NavItem>
          <NavLink href="/privacy3" style={ {fontSize : 20,color: "#1a1515"} }>
              <FontAwesomeIcon icon={faImage} className="mr-2" style={ {marginRight : 10} } />
              {t("privacy_policy")}
            </NavLink>
          </NavItem>
          {/* <NavItem>
          <NavLink to="../content/Content2" style={ {fontSize : 20,color: "#fff"} }>
              <FontAwesomeIcon icon={faQuestion} className="mr-2" style={ {marginRight : 10} } />
              FAQ
            </NavLink>
          </NavItem> */}
          <NavItem>
          <NavLink href="/contact" style={ {fontSize : 20,color: "#1a1515"} }>
              <FontAwesomeIcon icon={faPaperPlane} className="mr-2" style={ {marginRight : 10} } />
              {t("contact")}
            </NavLink>
          </NavItem>

          {/* <NavItem>
          <NavLink href="/worldwide" style={ {fontSize : 20,color: "#fff"} }>
              <FontAwesomeIcon icon={faPaperPlane} className="mr-2" style={ {marginRight : 10} } />
              World Wide CCTV
            </NavLink>
          </NavItem> */}


        </Nav>
      </div>
    );
  }
}

export default withTranslation()(SideBar);
